/* Cellenium · textos centralizados em formato de funil
   Para cada parágrafo centralizado com 2+ linhas, escolhe onde quebrar as
   linhas para que cada uma fique do mesmo tamanho ou menor que a de cima
   (funil), sem deixar uma ou duas palavras soltas no fim.
   Só mexe em texto simples (sem negrito/links dentro) e centralizado;
   textos alinhados à esquerda (leitura em F) não são tocados.
   Recalcula ao redimensionar a tela. */
(function(){
  var SEL='main p, main small, footer p';
  var ctx=document.createElement('canvas').getContext('2d');

  function medidor(el){
    var cs=getComputedStyle(el);
    ctx.font=cs.fontStyle+' '+cs.fontWeight+' '+cs.fontSize+' '+cs.fontFamily;
    var ls=parseFloat(cs.letterSpacing)||0;
    return function(t){return ctx.measureText(t).width+ls*t.length};
  }
  function contarLinhas(el){
    var r=document.createRange();r.selectNodeContents(el);
    var tops=[];
    [].forEach.call(r.getClientRects(),function(x){
      if(x.width>1&&!tops.some(function(t){return Math.abs(t-x.top)<x.height*.5}))tops.push(x.top);
    });
    return tops.length;
  }
  /* melhor divisão das palavras em k linhas: cada linha do mesmo tamanho ou
     menor que a de cima (funil). Quando uma palavra longa impede o funil
     perfeito, escolhe a forma mais próxima. Programação dinâmica. */
  function dividir(words,wd,sp,max,k){
    var n=words.length,memo={};
    function larg(a,b){var s=0;for(var i=a;i<b;i++)s+=wd[i];return s+sp*(b-a-1)}
    function passo(prevW,w){                    /* custo de uma linha depois da outra */
      if(w>prevW+2){var d=(w-prevW)/max;return 400*d*d+150}
      var q=(prevW-w)/max;return 60*q*q;
    }
    /* menor custo para arrumar words[s..] em "left" linhas, sabendo a largura da anterior */
    function f(ps,s,left){
      var key=ps+','+s+','+left;if(key in memo)return memo[key];
      var prevW=larg(ps,s),res={c:Infinity,q:null};
      if(left===1){
        var w=larg(s,n);
        if(w<=max){res={c:passo(prevW,w)+(w<prevW*0.5?400:0),q:[n]}}
      }else{
        for(var e=s+1;e<=n-left+1;e++){
          var w2=larg(s,e);if(w2>max)break;
          var r=f(s,e,left-1);if(r.c===Infinity)continue;
          var c=passo(prevW,w2)+r.c;
          if(c<res.c)res={c:c,q:[e].concat(r.q)};
        }
      }
      memo[key]=res;return res;
    }
    var best={c:Infinity};
    for(var e=1;e<=n-k+1;e++){
      var w=larg(0,e);if(w>max)break;
      var r=k===1?{c:0,q:[]}:f(0,e,k-1);
      if(r.c===Infinity)continue;
      var c=r.c+(1-w/max)*40;                  /* aproveita a largura da 1ª linha */
      if(c<best.c)best={c:c,quebras:[e].concat(r.q)};
    }
    return best.c===Infinity?null:best;
  }
  function ajustar(el){
    if(el.dataset.funilOrig!==undefined){el.textContent=el.dataset.funilOrig}
    var cs=getComputedStyle(el);
    if(cs.textAlign!=='center')return;
    /* com negrito/link/ícone dentro: só equilibra as linhas (sem palavra solta) */
    if(el.children.length){el.style.textWrap='balance';return}
    var max=el.getBoundingClientRect().width-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight);
    if(max<100)return;
    var k0=contarLinhas(el);if(k0<2)return;
    var texto=el.textContent.replace(/\s+/g,' ').trim(),words=texto.split(' ');
    if(words.length<4||words.length>70)return;
    var m=medidor(el),sp=m(' '),wd=words.map(m);
    var melhor=null;
    for(var k=k0;k<=k0+2;k++){
      var r=dividir(words,wd,sp,max+0.5,k);
      if(r){r.c+=(k-k0)*60;if(!melhor||r.c<melhor.c)melhor=r}
    }
    if(!melhor)return;
    el.dataset.funilOrig=el.textContent;
    var partes=[],a=0;
    melhor.quebras.forEach(function(b){partes.push(words.slice(a,b).join(' '));a=b});
    el.textContent='';
    partes.forEach(function(p,i){if(i)el.appendChild(document.createElement('br'));el.appendChild(document.createTextNode(p))});
  }
  function tudo(){[].forEach.call(document.querySelectorAll(SEL),function(el){try{ajustar(el)}catch(e){}})}
  var t;function agendar(){clearTimeout(t);t=setTimeout(tudo,120)}
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(tudo);
  window.addEventListener('load',tudo);
  window.addEventListener('resize',agendar);
  document.addEventListener('shopify:section:load',agendar);
  document.addEventListener('click',function(){setTimeout(tudo,60)});
})();
